import { Dispatch, MutableRefObject, SetStateAction } from 'react'
import { PROGRAM_PAYOUT_TYPE_MAP } from '~/helpers/challenge'
import { FuturesCategory } from '~/types/offer'

export const ROUTES = {
  main: '/quick-checkout',
  challengeCfd: ({
    countryCode,
    program,
    ref,
  }: {
    countryCode: string
    program?: keyof typeof PROGRAM_PAYOUT_TYPE_MAP
    ref?: string
  }) => {
    let url = `/quick-checkout/challenge/cfd?country=${countryCode}`
    if (program) {
      url += `&program=${program}`
    }

    if (ref) {
      url += `&ref=${ref}`
    }
    return url
  },
  challengeFutures: ({
    countryCode,
    request,
    program,
    ref,
  }: {
    countryCode: string
    request?: Request
    program?: keyof typeof PROGRAM_PAYOUT_TYPE_MAP
    ref?: string
  }) => {
    const params = new URLSearchParams(request ? new URL(request.url).searchParams : '')
    params.set('country', countryCode)
    if (program) {
      params.set('program', String(program))
    }

    if (ref) {
      params.set('ref', ref)
    }
    return `/quick-checkout/challenge/futures?${params.toString()}`
  },
  personalDetails: (
    countryCode: string,
    from: 'cfd' | 'futures',
    program: keyof typeof PROGRAM_PAYOUT_TYPE_MAP,
    ref?: string,
  ) => {
    let url = `/quick-checkout/personal-details?country=${countryCode}&from=${from}&program=${program}`

    if (ref) {
      url += `&ref=${ref}`
    }
    return url
  },
  checkout: (countryCode: string, from: 'cfd' | 'futures', program: keyof typeof PROGRAM_PAYOUT_TYPE_MAP) => {
    let url = new URL('/quick-checkout/payment', window.location.origin)

    url.searchParams.set('country', countryCode)
    url.searchParams.set('from', from)
    url.searchParams.set('program', program)

    return url.pathname + '?' + url.searchParams.toString()
  },
}

export const ROUTE_IDS = {
  challengeCfd: 'routes/quick-checkout/challenge/cfd',
  challengeFutures: 'routes/quick-checkout/challenge/futures',
  personalDetails: 'routes/quick-checkout/personal-details',
  checkout: 'routes/quick-checkout/payment',
}

export type QCStep = {
  label: string
  slug: 'challenge' | 'personal-details' | 'payment'
  routeId: Array<string> | string
}

export type PrefillClientDetails = {
  title: string
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  countryKey: string
  city: string
  state: string
  postCode: string
  address: string

  acceptTerms: boolean
  acknowledgePersonalData: boolean
  subscribeNewsletter: boolean
  cfdDisclaimer: boolean
}
export type ChallengeData = {
  prefillClientDetails?: PrefillClientDetails
  [key: string]: any // TODO: add correct typing
}

export type CFDSelectionsRef = { program?: number | null, type?: number | null, balance?: number, platform?: number | null } | null

export const FuturesTabs = {
  selection: 'selection',
  addons: 'addons',
} as const

export type QuickCheckoutOutletData = {
  challengeData: ChallengeData
  setChallengeData: (newChallengeData: ChallengeData) => void
  mainDomainUrl: string
  cfdSelectionsRef: MutableRefObject<CFDSelectionsRef>
  futures: {
    tab: keyof typeof FuturesTabs
    setTab: Dispatch<SetStateAction<keyof typeof FuturesTabs>>
    selectedChallenge: FuturesCategory | null
    setSelectedChallenge: Dispatch<SetStateAction<FuturesCategory | null>>
  }
}

export type ChallengeOutletData = {
  selectedProgram: Program
  setSelectedProgram: React.Dispatch<React.SetStateAction<number>>
} & QuickCheckoutOutletData

export const ASSET_TYPES = {
  futures: 'futures',
  cfd: 'cfd',
} as const

export type Asset = keyof typeof ASSET_TYPES

export type Platform = {
  id: number
  name: string // Maybe: MT4 | MT5
  displayName: string
  enabled: boolean
}

export const PROGRAMS = {
  prime: 2,
  classic: 1,
}
export type Program = number
